interface StatusCardProps {
  count: number;
  label: string;
  color: 'blue' | 'amber' | 'orange' | 'green' | 'gray';
  isActive: boolean;
  onClick: () => void;
}

const colorStyles = {
  blue: {
    base: 'bg-blue-50 border-blue-200',
    active: 'bg-blue-100 border-blue-400 ring-2 ring-blue-300',
    text: 'text-blue-700',
    subtext: 'text-blue-600',
  },
  amber: {
    base: 'bg-amber-50 border-amber-200',
    active: 'bg-amber-100 border-amber-400 ring-2 ring-amber-300',
    text: 'text-amber-700',
    subtext: 'text-amber-600',
  },
  orange: {
    base: 'bg-orange-50 border-orange-200',
    active: 'bg-orange-100 border-orange-400 ring-2 ring-orange-300',
    text: 'text-orange-700',
    subtext: 'text-orange-600',
  },
  green: {
    base: 'bg-green-50 border-green-200',
    active: 'bg-green-100 border-green-400 ring-2 ring-green-300',
    text: 'text-green-700',
    subtext: 'text-green-600',
  },
  gray: {
    base: 'bg-gray-100 border-gray-300',
    active: 'bg-gray-200 border-gray-500 ring-2 ring-gray-400',
    text: 'text-gray-700',
    subtext: 'text-gray-600',
  },
};

export function StatusCard({ count, label, color, isActive, onClick }: StatusCardProps) {
  const styles = colorStyles[color];

  return (
    <button
      onClick={onClick}
      className={`rounded-lg border p-2 text-center transition-all ${
        isActive ? styles.active : styles.base
      } hover:opacity-80 active:scale-95`}
    >
      <div className={`text-xl font-bold ${styles.text}`}>{count}</div>
      <div className={`text-xs font-medium ${styles.subtext}`}>{label}</div>
    </button>
  );
}
